import React, { useEffect } from "react";
import MainLayout from "../../components/Layout/MainLayout";
import MainPage from "../../components/Leads/MainPage";

const IndexPage = () => {
  useEffect(() => {
    document.title = "Leads - Prime Bridge Admin";
  }, []);
  return (
    <MainLayout>
      <MainPage />
    </MainLayout>
  );
};

export default IndexPage;
